import React, { Component } from 'react';

export default class Logo extends Component {
    render() {
        return <h1 className="logo">
            <span className="color-dark">Safe</span><span className="color-medium-light">Sex</span><span className="color-dark">Stats</span>
            <span className="tagline">Contraceptive Effectiveness Calculator</span>
        </h1>
    }
}
